import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import { Port1State, Port1Params, Port1ApiResponse } from "./Port1Type";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";

//情報取得API連携
export const fetchAsyncPort1Info: any = createAsyncThunk<
  Port1ApiResponse,
  Port1Params
>("port1/get", async () => {
  const response = await axiosSettings.get("api-admin/port1");
  return response.data;
});

const initialState: Port1State = {
  port1Status: null,
  updatedTime: "",
  loading: false,
  error: "",
};

const Port1InfoSlice = createSlice({
  name: "Port1Info",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncPort1Info.fulfilled, (state, action) => {
      if ((action.payload.status = "Success")) {
        state.port1Status = action.payload.data.result;
        state.updatedTime = GetTime();
        state.error = "";
      } else {
        state.error = action.payload.data.result;
      }
      state.loading = false;
    });
    builder.addCase(fetchAsyncPort1Info.pending, (state) => {
      state.loading = true;
    });
  },
});

export const Port1Status = (state: RootState) => state.Port1Info.port1Status;
export const Port1Error = (state: RootState) => state.Port1Info.error;
export const Port1Loading = (state: RootState) => state.Port1Info.loading;
export const Port1UpdatedTime = (state: RootState) =>
  state.Port1Info.updatedTime;
export default Port1InfoSlice.reducer;
